<template>
  <v-card data-testid="tool_static_pdf">
    <v-card-title style="padding: 0px;">
      <v-toolbar grey flat>
        <v-btn icon @click="close" data-testid="tool_static_pdf_close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-divider />
    <v-card-text class="mt-4">
      <div v-if="description"> {{ description }} </div>
    </v-card-text>

    <v-card-actions>
      <v-btn v-if="has_view" @click="view()" data-testid="tool_static_pdf_view">{{ $t("common.view") }}</v-btn>
      <v-spacer />
      <v-btn color="primary" @click="print()" data-testid="tool_static_pdf_print">{{ $t("common.print") }}</v-btn>
    </v-card-actions>
    <v-progress-linear v-if="in_flight" :indeterminate="true" />
  </v-card>
</template>

<script>
import * as print_pdf from "../../lib/print_pdf";

export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    uri: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: ""
    },
  },
  data() {
    let data = {
      in_flight: false,
    };
    return data;
  },
  computed: {
    has_view() {
      let has_view = print_pdf.has_view();
      return has_view;
    },
  },
  methods: {
    view: function () {
      print_pdf.view(this.uri);
    },
    print: function () {
      print_pdf.print(this.uri, "landscape", this);
    },
    close: function () {
      this.$emit("close");
    },
  },
};
</script>
